import React from "react";

function TopHeader(props) {
  return (
    <div className="admin-stats-container flex-sm-wrap align-items-center justify-content-center download-info">
    <div className="stats-container flex-sm-wrap align-items-center justify-content-center">
      <div className="shadow-sm">
        <div>
          <h3>{props.stats1}</h3>
          <p className="admin-stats-desc">In Total</p>
        </div>
        <img src="./Images/green_cube.png" alt="Green cube" />
      </div>
      <div className="shadow-sm">
        <div>
          <h3>{props.stats2}</h3>
          <p className="admin-stats-desc">This Month</p>
        </div>
        <img src="./Images/orange_cube.png" alt="Orange cube" />
      </div>
      <div className="shadow-sm">
        <div>
          <h3>{props.stats3}</h3>
          <p className="admin-stats-desc">In Total</p>
        </div>
        <img src="./Images/green_cube.png" alt="Green cube" />
      </div>
    </div>
  </div>
  );
}

export default TopHeader;
